import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalConfig} from 'src/global';
import {HttpService} from '../service/http.service';

@Component({
  selector: 'app-champ-page',
  templateUrl: './champ-page.component.html',
  styleUrls: ['./champ-page.component.css']
})
export class ChampPageComponent implements OnInit {
  noWinnersList: boolean;
  winnersList: any;
  type: any;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private http: HttpService) {
  }

  ngOnInit(): void {
    this.checkSessionStorage();
  }

  checkSessionStorage() {
    this.type = this.activatedRoute.snapshot.paramMap.get('type');
    if (this.type == 'city') {
      this.getWinnersByCity();
    } else {
      this.getWinnersByCountry();
    }
  }

  getWinnersByCity() {
    this.http.getKazWinners().subscribe((data: any) => {
      if (data.length === 0) {
        this.noWinnersList = true;
      } else {
        this.winnersList = data;
      }
    });
  }

  getWinnersByCountry() {
    this.http.getWinnersByCountryService(null).subscribe((data: any) => {
      if (data.length === 0) {
        this.noWinnersList = true;
      } else {
        this.winnersList = data;
      }
    });
  }

  redirectToWinnersPage(item) {
    let winnerId = item.id;
    this.router.navigate([this.type + '/winners/', winnerId]);
  }

}
